<div class="money-back-guarantee-popup-wrapper">
  <div
    class="money-back-guarantee-popup"
    [ngClass]="{ 'money-back-guarantee-popup--reverse-text': withReverseText }"
  >
    <div class="money-back-guarantee-popup__header" (click)="openContent()">
      <app-svg-icon
        class="money-back-guarantee-popup__header_checkmark"
        icon="checkmark-icon"
        fill="semantic-tropical-green"
        size="medium"
      ></app-svg-icon>
      <div class="money-back-guarantee-popup__header_text">
        @if (title) {
        <p
          class="money-back-guarantee-popup__header_text_title"
          [ngClass]="{
            'money-back-guarantee-popup__header_text_title--no-subtitle':
              !subtitle
          }"
        >
          {{ title }}
          <app-svg-icon
            class="money-back-guarantee-popup__header_text_title_info-icon"
            icon="info-icon"
            stroke="grays-text-light-gray"
            size="xsmall"
          ></app-svg-icon>
        </p>
        } @if (subtitle) {
        <p class="money-back-guarantee-popup__header_text_subtitle">
          {{ subtitle }}
        </p>
        }
      </div>
    </div>
    @if (showContent) {
    <div class="money-back-guarantee-popup__content">
      <div class="money-back-guarantee-popup__content_top">
        @if (contentTitle) {
        <p class="money-back-guarantee-popup__content_top_title">
          {{ contentTitle }}
        </p>
        }
        <app-svg-icon
          class="money-back-guarantee-popup__content_top_close-icon"
          icon="close-icon"
          size="small"
          fill="grays-space-gray"
          (click)="closeContent()"
        >
        </app-svg-icon>
      </div>
      <div class="money-back-guarantee-popup__content_body">
        @if (description) {
        <p class="money-back-guarantee-popup__content_body_description">
          {{ description }}
        </p>
        } @if (note) {
        <p class="money-back-guarantee-popup__content_body_note">
          {{ note }}
        </p>
        }
      </div>
    </div>
    }
  </div>
</div>
